const CandidateForm = () =>
  import(/* webpackChunkName: "management" */ '@/views/form/Candidate.vue')
const PersonalDataAgreement = () =>
  import(/* webpackChunkName: "candidate" */ '@/views/form/PersonalDataAgreement.vue')
const ManagerForm = () => import(/* webpackChunkName: "management" */ '@/views/form/Manager.vue')
const ViewForm = () => import(/* webpackChunkName: "management" */ '@/views/form/ReadOnly.vue')
const EditForm = () => import(/* webpackChunkName: "management" */ '@/views/form/Edit.vue')

const router = [
  {
    path: 'A/:formId/:accessToken',
    name: 'formA',
    component: CandidateForm,
    meta: {
      noAuth: true,
    },
  },
  {
    path: 'personal-data-agreement',
    component: PersonalDataAgreement,
    meta: {
      noAuth: true,
    },
  },
  {
    path: 'B/:formId',
    name: 'formB',
    component: ManagerForm,
  },
  {
    path: 'view/:formId',
    name: 'viewFormsData',
    component: ViewForm,
  },
  {
    path: 'edit/:formId',
    name: 'editFormsData',
    component: EditForm,
  },
]

export default router
